import { useBucket } from '@mc/experiments-react'

// Growthbook experiment: https://app.growthbook.io/features/dais-3587_v1_persona_prepw_quiz
export const PRE_PW_QUIZ_FLAG = 'dais-3587_v1_persona_prepw_quiz'

export const useIsPrepwQuizEnabled = () => {
  const bucket = useBucket<'control' | 'variant_1'>(PRE_PW_QUIZ_FLAG)

  return bucket === 'variant_1'
}
